import React from 'react';
import { Cloud, Rocket, Code } from 'phosphor-react';
import './App.css';
import Footer from './Footer';

function Home() {
  return (
    <div className="App">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">Lilley Tech Syndicate</h1>
          <p className="hero-tagline">Engineering Tomorrow's Digital Ecosystem</p>
          <p className="hero-description">
            Advancing proprietary tech and ventures for boundless innovation.
          </p>
        </div>
      </section>

      {/* About Section */}
      <section className="about" id="about">
        <div className="container">
          <h2 className="section-title">About Us</h2>
          <div className="about-content">
            <p className="about-text">
              Lilley Tech Syndicate LLC is a technology holding company that develops and operates 
              proprietary software products and related ventures. We leverage technical expertise and 
              innovation to deliver transformative digital solutions.
            </p>
            <p className="about-text">
              We advance industry trends through modern tools and methodologies. Our portfolio includes 
              diverse software and interconnected ventures that expand digital capabilities.
            </p>
            <p className="about-text">
              Lilley Tech Syndicate supports the growth of specialized subsidiaries, each providing 
              value in targeted domains via dedicated websites and offerings.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" id="services">
        <div className="container">
          <h2 className="section-title">What We Do</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <Code size={48} weight="regular" />
              </div>
              <h3 className="service-title">Proprietary Software Development</h3>
              <p className="service-description">
                Building and operating our own software products using modern technologies and 
                methodologies to drive transformative digital solutions.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <Cloud size={48} weight="regular" />
              </div>
              <h3 className="service-title">Cloud Infrastructure</h3>
              <p className="service-description">
                Designing scalable cloud systems that power our ventures and enable seamless 
                growth across our portfolio.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <Rocket size={48} weight="regular" />
              </div>
              <h3 className="service-title">Technology Ventures</h3>
              <p className="service-description">
                Fostering innovative spin-offs and subsidiaries, each delivering cutting-edge 
                value in specialized domains through dedicated platforms and offerings.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact" id="contact">
        <div className="container">
          <h2 className="section-title">Get In Touch</h2>
          <div className="contact-content">
            <div className="business-card">
              <h3 className="business-card-title">Lilley Tech Syndicate LLC</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="contact-label">Address</span>
                  <span className="contact-value">30 N Gould St Ste N<br />Sheridan, SHERIDAN COUNTY, WY 82801<br />USA</span>
                </div>
                <div className="contact-item">
                  <span className="contact-label">Phone</span>
                  <span className="contact-value"><a href="tel:+13072045225">(307) 204-5225</a></span>
                </div>
                <div className="contact-item">
                  <span className="contact-label">Email</span>
                  <span className="contact-value"><a href="mailto:karl.lilley@gmail.com">karl.lilley@gmail.com</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Home;
